[
  {
    "id": "round",
    "x": 16,
    "y": 20,
    "w": 238,
    "h": 94
  },
  {
    "id": "logo",
    "x": 288,
    "y": 8,
    "w": 404,
    "h": 250
  },
  {
    "id": "sticker.l",
    "x": 56,
    "y": 138,
    "w": 174,
    "h": 132
  },
  {
    "id": "sticker.r",
    "x": 798,
    "y": 178,
    "w": 142,
    "h": 136
  },
  {
    "id": "seat4.ring",
    "x": 452,
    "y": 258,
    "w": 192,
    "h": 176
  },
  {
    "id": "seat1.ring",
    "x": 18,
    "y": 282,
    "w": 158,
    "h": 152
  },
  {
    "id": "seat2.ring",
    "x": 176,
    "y": 282,
    "w": 144,
    "h": 152
  },
  {
    "id": "seat3.ring",
    "x": 320,
    "y": 282,
    "w": 132,
    "h": 152
  },
  {
    "id": "seat5.ring",
    "x": 644,
    "y": 282,
    "w": 136,
    "h": 152
  },
  {
    "id": "seat6.ring",
    "x": 780,
    "y": 282,
    "w": 148,
    "h": 152
  },
  {
    "id": "seat1.pill",
    "x": 26,
    "y": 434,
    "w": 144,
    "h": 34
  },
  {
    "id": "seat2.pill",
    "x": 170,
    "y": 434,
    "w": 142,
    "h": 34
  },
  {
    "id": "seat3.pill",
    "x": 314,
    "y": 434,
    "w": 142,
    "h": 34
  },
  {
    "id": "seat4.pill",
    "x": 470,
    "y": 434,
    "w": 156,
    "h": 34
  },
  {
    "id": "seat5.pill",
    "x": 630,
    "y": 434,
    "w": 142,
    "h": 34
  },
  {
    "id": "seat6.pill",
    "x": 776,
    "y": 434,
    "w": 144,
    "h": 34
  },
  {
    "id": "question",
    "x": 52,
    "y": 466,
    "w": 836,
    "h": 246
  },
  {
    "id": "row1",
    "x": 109,
    "y": 687,
    "w": 720,
    "h": 118,
    "shape": {
      "kind": "pill",
      "n": [
        129,
        707,
        809,
        784
      ],
      "glow": 20
    }
  },
  {
    "id": "row2",
    "x": 109,
    "y": 773,
    "w": 720,
    "h": 118,
    "shape": {
      "kind": "pill",
      "n": [
        129,
        793,
        809,
        870
      ],
      "glow": 20
    }
  },
  {
    "id": "row3",
    "x": 109,
    "y": 859,
    "w": 720,
    "h": 116,
    "shape": {
      "kind": "pill",
      "n": [
        129,
        879,
        809,
        954
      ],
      "glow": 20
    }
  },
  {
    "id": "row4",
    "x": 109,
    "y": 944,
    "w": 720,
    "h": 117,
    "shape": {
      "kind": "pill",
      "n": [
        129,
        964,
        809,
        1040
      ],
      "glow": 20
    }
  },
  {
    "id": "row5",
    "x": 109,
    "y": 1031,
    "w": 720,
    "h": 117,
    "shape": {
      "kind": "pill",
      "n": [
        129,
        1051,
        809,
        1127
      ],
      "glow": 20
    }
  },
  {
    "id": "row6",
    "x": 109,
    "y": 1127,
    "w": 720,
    "h": 91,
    "shape": {
      "kind": "pill",
      "n": [
        129,
        1137,
        809,
        1213
      ],
      "glow": 10
    }
  },
  {
    "id": "alltheway",
    "x": 102,
    "y": 1223,
    "w": 736,
    "h": 133
  },
  {
    "id": "cta",
    "x": 90,
    "y": 1349,
    "w": 760,
    "h": 145
  },
  {
    "id": "callit",
    "x": 146,
    "y": 1494,
    "w": 648,
    "h": 78
  }
]
